<template>
  <div class="cmp-distribution-reports-main-container">
    <div class="main-header">
      <div>
        <h4>CREATE SALES REPORT</h4>
        <span>Fill in the following information to create a new Report</span>
      </div>
      <div>
        <MenuButton
          @click="onMenuClicked"
          :options="moreReportsTV"
          :label="'More Reports'"
        />
      </div>
    </div>
    <div class="content-container">
      <div class="left-box">
        <div class="box">
          <h4>{{ $t('report_items') }}</h4>
          <div class="tag">
            <div
              v-for="(item, index) in filteredData.items"
              :key="item.key"
              class="chip-container"
            >
              <div class="chip-content">{{ item.value }}</div>
              <div class="chip-close" @click="removeItem(index, item)">
                <img src="static/icons/close.svg" class="dt-icon" />
              </div>
            </div>
          </div>
          <button
            @click="onAddClick('report_items_form')"
            class="dt-button v3 c5 txtov"
          >
            + {{ $t('add_filter') }}
          </button>
        </div>
        <div class="box">
          <h4>{{$t('account')}}</h4>
          <div class="tag">
            <div
              v-for="(account, index) in filteredData.accounts"
              :key="account.account_id"
              class="chip-container"
            >
              <div class="chip-content">{{ account.account_name }}</div>
              <div class="chip-close" @click="remove(index, 'account')">
                <!-- <svg
                  class="chip-svg"
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
                  ></path>
                </svg> -->
                <img src="static/icons/close.svg" class="dt-icon" />
              </div>
            </div>
          </div>

          <button
            @click="onAddClick('account_report_form')"
            class="dt-button v3 c5 txtov"
          >
            + {{ $t('add_filter') }}
          </button>
        </div>
        <div class="box">
          <h4>{{ $t('shop') }}</h4>
          <div class="tag">
            <div
              v-for="(shop, index) in filteredData.shops"
              :key="shop"
              class="chip-container"
            >
              <div class="chip-content">{{ shop }}</div>
              <div class="chip-close" @click="remove(index, 'shop')">
                <img src="static/icons/close.svg" class="dt-icon" />
              </div>
            </div>
          </div>
          <button
            @click="onAddClick('shop_report_form')"
            class="dt-button v3 c5 txtov"
          >
            + {{ $t('add_filter') }}
          </button>
        </div>

        <div class="box">
          <h4>{{$t('country')}}</h4>
          <div class="tag">
            <div
              v-for="(country, index) in filteredData.countries"
              :key="country.country_id"
              class="chip-container"
            >
              <div class="chip-content">{{ country.country_fullname }}</div>
              <div class="chip-close" @click="remove(index, 'country')">
                <img src="static/icons/close.svg" class="dt-icon" />
              </div>
            </div>
          </div>
          <button
            @click="onAddClick('country_report_form')"
            class="dt-button v3 c5 txtov"
          >
            + {{ $t('add_filter') }}
          </button>
        </div>
        <div class="box">
          <h4>{{$t('format')}}</h4>
          <div class="tag">
            <div
              v-for="(format, index) in filteredData.formats"
              :key="format.format_id"
              class="chip-container"
            >
              <div class="chip-content">{{ format.format_name }}</div>
              <div class="chip-close" @click="remove(index, 'format')">
                <img src="static/icons/close.svg" class="dt-icon" />
              </div>
            </div>
          </div>
          <button
            @click="onAddClick('format_report_form')"
            class="dt-button v3 c5 txtov"
          >
            + {{ $t('add_filter') }}
          </button>
        </div>
      </div>

      <div class="right-box">
        <div class="box">
          <div style="padding-bottom: 10px" class="type">
            <h5>Type</h5>
            <SelectTree
              style="padding-left: 10px"
              :tree="permTypeTree"
              @changed="onPermTreeChange"
            />
          </div>
          <div class="type">
            <h5>Bundle/Track(digital only)</h5>
            <SelectTree
              style="padding-left: 10px"
              :tree="permTree"
              @changed="onPermTreeChange"
            />
          </div>
        </div>
        <div class="date-box">
          <Dropdown2
            :label="$t('Sales Period')"
            style="width: 100%; margin-right: 30px"
            :placeholder="'Select ' + $t('Period')"
            :showLabel="false"
            :selected="
              periodTypeTV.find((v) => v.value == filteredData.period_type)
            "
            v-on:selectedChange="(e) => onPeriodTypeChange('period_type', e)"
            :options="periodTypeTV"
          />
          <DatePicker2
            id="from_date"
            :label="$t('from')"
            style="width: 100%; margin-right: 30px"
            :showLabel="false"
            :placeholder="$t('from')"
            :value="filteredData.from_date"
            @input="onDateUpdate"
          />
          <DatePicker2
            id="to_date"
            :label="$t('to')"
            :showLabel="false"
            :placeholder="$t('to')"
            style="width: 100%"
            :value="filteredData.to_date"
            @input="onDateUpdate"
          />
        </div>
        <div class="action-box">
          <button
            @click="onExtraResultClick('add_extra_result_form')"
            class="dt-button"
          >
            {{ $dft.snakeCaseToWords("Summarized Report") }}
          </button>
          <button @click="onSelectedSalesReport" class="dt-button">
            {{ $dft.snakeCaseToWords("Raw Sales Report") }}
          </button>
        </div>
      </div>
      <div class="large-screen">
        <div class="date-box">
          <Dropdown2
            :label="$t('Sales Period')"
            style="width: 100%; margin-right: 30px"
            :placeholder="'Select ' + $t('Period')"
            :showLabel="false"
            :selected="
              periodTypeTV.find((v) => v.value == filteredData.period_type)
            "
            v-on:selectedChange="(e) => onPeriodTypeChange('period_type', e)"
            :options="periodTypeTV"
          />
          <DatePicker2
            id="from_date"
            :label="$t('from')"
            style="width: 100%; margin-right: 30px"
            :showLabel="false"
            :placeholder="$t('from')"
            :value="filteredData.from_date"
            @input="onDateUpdate"
          />
          <DatePicker2
            id="to_date"
            :label="$t('to')"
            :showLabel="false"
            :placeholder="$t('to')"
            style="width: 100%"
            :value="filteredData.to_date"
            @input="onDateUpdate"
          />
        </div>
        <div class="action-box">
          <button
            @click="onExtraResultClick('add_extra_result_form')"
            class="dt-button"
          >
            {{ $dft.snakeCaseToWords("Summarized Report") }}
          </button>
          <button @click="onSelectedSalesReport" class="dt-button">
            {{ $dft.snakeCaseToWords("Raw Sales Report") }}
          </button>
        </div>
      </div>
    </div>

    <ModalContainer :modalKey="'countryReportForm'" :width="'550'">
      <countryReportForm
        @cancelled="onDialogCancelled"
        @selected="onReportItemAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'accountReportForm'" :width="'550'">
      <accountReportForm
        @cancelled="onDialogCancelled"
        @selected="onReportItemAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'formatReportForm'" :width="'550'">
      <formatReportForm
        @cancelled="onDialogCancelled"
        @selected="onReportItemAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'shopReportForm'" :width="'550'">
      <shopReportForm
        @cancelled="onDialogCancelled"
        @selected="onReportItemAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'reportItemsForm'" :width="'small'">
      <reportItemsForm
        @cancelled="onDialogCancelled"
        @selected="onReportItemAdded"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'addLabelsItemsForm'" :width="'medium'">
      <addLabelsItemsForm
        @cancelled="onDialogCancelled"
        @selected="onReportItemAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addProductsItemsForm'" :width="'medium'">
      <addProductsItemsForm
        @cancelled="onDialogCancelled"
        @selected="onReportItemAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addReleasesItemsForm'" :width="'medium'">
      <addReleasesItemsForm
        @cancelled="onDialogCancelled"
        @selected="onReportItemAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addTracksItemsForm'" :width="'medium'">
      <addTracksItemsForm
        @cancelled="onDialogCancelled"
        @selected="onReportItemAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addExtraResultForm'" :width="'small'">
      <addExtraResultForm
        @emitData="getReport"
        :filteredData="filteredData"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'labelReportModal'" :width="'medium'">
      <labelReportModal
        @emitData="getReport"
        :filteredData="filteredData"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'openOrderReportModal'" :width="'600'">
      <openOrderReportModal
        @emitData="getReport"
        :filteredData="filteredData"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'productReportModal'" :width="'small'">
      <productReportModal
        @emitData="getReport"
        :filteredData="filteredData"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'releaseReportModal'" :width="'small'">
      <releaseReportModal
        @emitData="getReport"
        :filteredData="filteredData"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'stockReportModal'" :width="'small'">
      <stockReportModal
        @emitData="getReport"
        :filteredData="filteredData"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'shopManagementReportModal'" :width="'medium'">
      <shopManagementReportModal
        @emitData="getReport"
        :filteredData="filteredData"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'costReportModal'" :width="'small'">
      <costReportModal
        @emitData="getReport"
        :filteredData="filteredData"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
  </div>
</template>

<script>
import { SelectTree, createNode } from "../../../../plugins/select-tree";
import { ReportService } from "../../services/reports.service";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import countryReportForm from "./country-report.vue";
import accountReportForm from "./account-report.vue";
import formatReportForm from "./format-report.vue";
import shopReportForm from "./shop-report.vue";
import reportItemsForm from "./report-items.vue";
import addLabelsItemsForm from "./add-labels-items.vue";
import addProductsItemsForm from "./add-products-items.vue";
import addReleasesItemsForm from "./add-releases-items.vue";
import addTracksItemsForm from "./add-tracks-items.vue";
import addExtraResultForm from "./extra-result-table.vue";

import labelReportModal from "./label-report-modal.vue";
import openOrderReportModal from "./open-order-report-modal.vue";
import productReportModal from "./product-report-modal.vue";
import releaseReportModal from "./release-report-modal.vue";
import shopManagementReportModal from "./shop-management-report-modal.vue";
import stockReportModal from "./stock-report-modal.vue";
import costReportModal from "./cost-report-modal.vue";
import MenuButton from "./menuButton.vue";
import {
  NotificationService,
  showNotification,
  showError,
} from "../../../../dt-plugins/notification/notification.service";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { reportsDistributionActions } from "../../store/reports/actions";
export default {
  components: {
    SelectTree,
    ModalContainer,
    countryReportForm,
    accountReportForm,
    formatReportForm,
    shopReportForm,
    reportItemsForm,
    addLabelsItemsForm,
    addProductsItemsForm,
    addReleasesItemsForm,
    addTracksItemsForm,
    MenuButton,
    addExtraResultForm,
    labelReportModal,
    openOrderReportModal,
    productReportModal,
    releaseReportModal,
    shopManagementReportModal,
    stockReportModal,
    costReportModal,
  },
  props: ["tabs"],
  data() {
    return {
      date: null,
      reportData: null,
      //tabs: [],
      token: "",
      filter: {
        accounts: [],
        account_texts: [],
        shops: [],
        countries: [],
        country_texts: [],
        formats: [],
        format_texts: [],
        labels: [],
        label_texts: [],
        releases: [],
        release_texts: [],
        products: [],
        product_texts: [],
        tracks: [],
        track_texts: [],
        physical: 0,
        digital: 0,
        usage_types: [],
        digital_bundle: 0,
        digital_track: 0,
        thirdparty: 0,
        performance: 0,
      },
      filteredData: {
        shops: [],
        labels: [],
        releases: [],
        products: [],
        tracks: [],
        accounts: [],
        formats: [],
        countries: [],
        items: [],
        from_date: null,
        to_date: null,
        period_type: "sales_period",
        physical: 0,
        digital: 0,
        usage_types: [],
        digital_bundle: 0,
        digital_track: 0,
        thirdparty: 0,
        performance: 0,
      },
    };
  },
  watch: {},
  computed: {
    moreReportsTV: function () {
      return [
        { text: "Stock Report", value: "stock_report_modal" },
        { text: "Label Report", value: "label_report_modal" },
        { text: "Release Export", value: "release_report_modal" },
        { text: "Product Export", value: "product_report_modal" },
        { text: "Open Order Report", value: "open_order_report_modal" },
        { text: "Shop Management", value: "shop_management_report_modal" },
        { text: "Cost Export", value: "cost_report_modal" },
      ];
    },
    periodTypeTV: function () {
      return [
        { text: "Sales Period", value: "sales_period" },
        { text: "Invoice Period", value: "invoice_period" },
        { text: "Payment Period", value: "payment_period" },
      ];
    },
    permTypeTree: function () {
      return [
        {
          text: "Physical",
          value: "Physical",
          selected: false,
          expanded: false,
          path: [0],
          children: [],
        },
        {
          text: "Digital",
          value: "Digital",
          selected: false,
          expanded: false,
          path: [1],
          children: [
            {
              path: [1, 0],
              selected: false,
              expanded: false,
              text: "Download Audio",
              value: "DL",
              children: [],
            },
            {
              path: [1, 1],
              selected: false,
              expanded: false,
              text: "Download Video",
              value: "DV",
              children: [],
            },
            {
              path: [1, 2],
              selected: false,
              expanded: false,
              text: "Streaming Audio",
              value: "STR",
              children: [],
            },
            {
              path: [1, 3],
              selected: false,
              expanded: false,
              text: "Streaming Video",
              value: "STV",
              children: [],
            },
            {
              path: [1, 4],
              selected: false,
              expanded: false,
              text: "Platform Promotion",
              value: "PROMO",
              children: [],
            },
          ],
        },
        {
          text: "Third Party",
          value: "Third Party",
          selected: false,
          expanded: false,
          path: [2],
          children: [],
        },
        {
          text: "Performance",
          value: "Performance",
          selected: false,
          expanded: false,
          path: [3],
          children: [],
        },
      ];
    },
    permTree: function () {
      return [
        {
          path: [0],
          selected: false,
          expanded: false,
          text: "Product",
          value: "Product",
          children: [],
        },
        {
          path: [1],
          selected: false,
          expanded: false,
          text: "Track",
          value: "Track",
          children: [],
        },
      ];
    },
  },
  created() {},
  mixins: [
    createModalMixin("countryReportForm"),
    createModalMixin("accountReportForm"),
    createModalMixin("formatReportForm"),
    createModalMixin("shopReportForm"),
    createModalMixin("reportItemsForm"),
    createModalMixin("addLabelsItemsForm"),
    createModalMixin("addProductsItemsForm"),
    createModalMixin("addReleasesItemsForm"),
    createModalMixin("addTracksItemsForm"),
    createModalMixin("addExtraResultForm"),

    createModalMixin("labelReportModal"),
    createModalMixin("openOrderReportModal"),
    createModalMixin("productReportModal"),
    createModalMixin("releaseReportModal"),
    createModalMixin("shopManagementReportModal"),
    createModalMixin("costReportModal"),
    createModalMixin("stockReportModal"),
  ],
  mounted: function () {
    this.getReportData();
  },
  methods: {
    ...mapActionObject(storeNS, reportsDistributionActions),
    setFilter() {
      this.filter.accounts = [];
      this.filter.account_texts = [];
      this.filter.shops = [];
      this.filter.countries = [];
      this.filter.country_texts = [];
      this.filter.formats = [];
      this.filter.format_texts = [];
      this.filter.labels = [];
      this.filter.label_texts = [];
      this.filter.releases = [];
      this.filter.release_texts = [];
      this.filter.products = [];
      this.filter.product_texts = [];
      this.filter.tracks = [];
      this.filter.track_texts = [];
      this.filteredData.labels.forEach((l) => {
        this.filter.labels.push(l.label_id);
        this.filter.label_texts.push(l.label_name);
      });
      this.filteredData.accounts.forEach((a) => {
        this.filter.accounts.push(a.account_id);
        this.filter.account_texts.push(a.account_name);
      });
      this.filteredData.releases.forEach((r) => {
        this.filter.releases.push(r.release_id);
        this.filter.release_texts.push(r.release_name);
      });
      this.filteredData.tracks.forEach((t) => {
        this.filter.tracks.push(t.track_id);
        this.filter.track_texts.push(t.track_name);
      });
      this.filteredData.countries.forEach((c) => {
        this.filter.countries.push(c.country_id);
        this.filter.country_texts.push(c.country_fullname);
      });
      this.filteredData.products.forEach((p) => {
        this.filter.products.push(p.product_id);
        this.filter.product_texts.push(p.product_name);
      });
      this.filteredData.formats.forEach((f) => {
        this.filter.formats.push(f.format_id);
        this.filter.format_texts.push(f.format_name);
      });
      this.filteredData.shops.forEach((s) => {
        this.filter.shops.push(s.shop_name);
      });
      this.filter[this.filteredData.period_type] = [
        this.filteredData.from_date,
        this.filteredData.to_date,
      ];
      this.filter.physical = this.filteredData.physical;
      this.filter.digital = this.filteredData.digital;
      this.filter.usage_types = this.filteredData.usage_types;
      this.filter.digital_bundle = this.filteredData.digital_bundle;
      this.filter.digital_track = this.filteredData.digital_track;
      this.filter.thirdparty = this.filteredData.thirdparty;
      this.filter.performance = this.filteredData.performance;
    },
    getReport(e) {
      const tab = {
        full_title: `Summarized Report (${e.token})`,
        title: `Summarized Report (${e.token})`,
        reportData: e.data,
        token: e.token,
        route: `summarized_report_${e.token}`,
        tabId: `summarized_report_${e.token}`,
        hideSideWindow: true,
      };
      this[ActionTypes.SET_DISTRIBUTION_REPORT_NAB_ITEMS]([...this.tabs, tab]);
      this.onDialogCancelled();
      this.$router.push({
        path: `/main/distribution/reports/summarized_report_${e.token}`,
      });
    },
    removeItem(index, e) {
      this.filteredData.items.splice(index, 1);
      switch (e.itemType) {
        case "labels":
          this.filteredData.labels = this.filteredData.labels.filter(
            (l) => l.label_id !== e.key
          );
          break;
        case "releases":
          this.filteredData.releases = this.filteredData.releases.filter(
            (l) => l.release_id !== e.key
          );
          break;
        case "products":
          this.filteredData.products = this.filteredData.products.filter(
            (l) => l.product_id !== e.key
          );
          break;
        case "tracks":
          this.filteredData.tracks = this.filteredData.tracks.filter(
            (l) => l.track_id !== e.key
          );
          break;
      }
    },
    remove(index, action) {
      console.log("action");
      switch (action) {
        case "items":
          this.filteredData.items.splice(index, 1);
          break;
        case "account":
          this.filteredData.accounts.splice(index, 1);
          break;
        case "shop":
          this.filteredData.shops.splice(index, 1);
          break;
        case "format":
          this.filteredData.formats.splice(index, 1);
          break;
        case "country":
          this.filteredData.countries.splice(index, 1);
          break;
      }
    },
    async onSelectedSalesReport() {
      this.setFilter();
      console.log("filter", this.filter);
      let curTime = new Date().getTime();
      this.token = "summarized_report_" + curTime;
      const result = await ReportService.getRawSalesReports({
        filter: this.filter,
        token: this.token,
      });
      setTimeout(() => {
        ReportService.checkReportStatus(this.token).then((result) => {
          if (result.data.status == "success") {
            const fileURL = ReportService.exportRawSalesReportData(this.token);
            location.href = fileURL;
          }
        });
      }, 3000);
    },
    onReportItemAdded(e) {
      switch (e.action) {
        case "items":
          switch (e.itemType) {
            case "labels":
              this.filteredData.labels = [];
              this.filteredData.labels.push(...e.labels);
              break;
            case "releases":
              this.filteredData.releases = [];
              this.filteredData.releases.push(...e.releases);
              break;
            case "products":
              this.filteredData.products = [];
              this.filteredData.products.push(...e.products);
              break;
            case "tracks":
              this.filteredData.tracks = [];
              this.filteredData.tracks.push(...e.tracks);
              break;
          }
          this.filteredData.items.push(...e.items);
          break;
        case "account":
          this.filteredData.accounts = [];
          this.filteredData.accounts.push(...e.items);
          break;
        case "shop":
          this.filteredData.shops = [];
          this.filteredData.shops.push(...e.items);
          break;
        case "format":
          this.filteredData.formats = [];
          this.filteredData.formats.push(...e.items);
          break;
        case "country":
          this.filteredData.countries = [];
          this.filteredData.countries.push(...e.items);
          break;
      }
      console.log("filteredData", this.filteredData);
      this.onDialogCancelled();
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onExtraResultClick: function (e) {
      if (!this.filteredData.to_date || !this.filteredData.to_date) {
        NotificationService.showNotification({
          text: "Please set start date and end date",
          type: "error",
          timeout: 5000,
        });
        return;
      }
      openModalRoute(this, e, {
        mode: "add",
      });
    },
    onAddClick: function (e) {
      openModalRoute(this, e, {
        mode: "add",
      });
    },
    onPermTreeChange(e) {
      console.log("tree", e);
      e.forEach((t) => {
        if (t.text == "Physical") {
          this.filteredData.physical = t.selected ? 1 : 0;
        }
        if (t.text == "Digital") {
          this.filteredData.usage_types = [];
          this.filteredData.digital = t.selected ? 1 : 0;
          t.children.forEach((c) => {
            if (c.selected) {
              this.filteredData.usage_types.push(c.value);
            }
          });
        }
        if (t.text == "Third Party") {
          this.filteredData.thirdparty = t.selected ? 1 : 0;
        }
        if (t.text == "Performance") {
          this.filteredData.performance = t.selected ? 1 : 0;
        }
        if (t.text == "Product") {
          this.filteredData.digital_bundle = t.selected ? 1 : 0;
        }
        if (t.text == "Track") {
          this.filteredData.digital_track = t.selected ? 1 : 0;
        }
      });

      console.log("filteredData", this.filteredData);
    },
    onDateUpdate: function ({ name, value }) {
      console.log({ name, value });
      this.filteredData[name] = value;
    },
    onPeriodTypeChange(name, value) {
      this.filteredData[name] = value.value;
    },
    onMenuClicked(e) {
      console.log("menu", e);
      openModalRoute(this, e.value, {
        mode: "add",
      });
    },
    getReportData: async function () {
      const result = await ReportService.getReportFilteredData();
      this.reportData = {
        ...this.reportData,
        ...result.data,
      };
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-reports-main-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: calc(100vh - 180px);
  padding: 10px 10px 0px 10px;
  overflow: auto;
  .main-header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding-bottom: 10px;
    h4 {
      color: #282828;
      font-weight: 500;
      text-transform: uppercase;
      opacity: 1;
      font: normal normal bold 13px/18px Roboto;
    }
  }
  .content-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media (min-width: 320px) and (max-width: 800px) {
      flex-direction: column;
    }
    .left-box {
      margin-right: 20px;
      width: 100%;
    }
    .right-box {
      width: 100%;
      @media only screen and (min-width: 1800px) {
        margin-right: 20px;
      }

      .box {
        padding: 5px 10px;
        .type {
          h5 {
            color: rgb(149, 149, 149);
            padding: 5px 0;
          }
        }
        &:hover {
          border: 1px solid #9b9a9a80;
        }
      }
      .date-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        border: 1px solid #c8c8c880;

        padding: 5px 5px 14px 20px;
        margin: 10px 0;
        border-radius: 5px;
        width: 100%;
        margin-bottom: 50px;
        @media only screen and (min-width: 1800px) {
          display: none;
        }
        &:hover {
          --fc2-bc: var(--bc-cblue);
          border: 1px solid #9b9a9a80;
        }
      }
      .action-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        @media only screen and (min-width: 1800px) {
          display: none;
        }
        .dt-button {
          margin-right: 2px !important;
          padding: 0 10px;
        }
      }
    }
    .box {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      border: 1px solid #c8c8c880;
      min-height: 50px;
      padding: 5px 10px;
      margin: 10px 0px;
      border-radius: 5px;
      &:hover {
        border: 1px solid #9b9a9a80;
      }
      .tag {
        .chip-container {
          display: inline-flex;
          flex-direction: row;
          background-color: #e5e5e5;
          border: none;
          cursor: default;
          height: 22px;
          outline: none;
          padding: 0;
          font-size: 11px;
          color: #333333;
          margin: 4px 4px 4px 0px;
          align-items: center;
          border-radius: 15px;
          vertical-align: middle;
          text-decoration: none;
          justify-content: center;
          .chip-content {
            cursor: inherit;
            display: flex;
            align-items: center;
            user-select: none;
            white-space: nowrap;
            padding-left: 12px;
            padding-right: 12px;
          }
          .chip-close {
            img {
              margin: -3px -5px -7px -15px;
              width: 30px;
            }
          }
          .chip-svg {
            color: #999999;
            cursor: pointer;
            height: auto;
            margin: 4px 4px 0 -8px;
            fill: currentColor;
            width: 1em;
            height: 1em;
            display: inline-block;
            font-size: 20px;
            transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
            user-select: none;
            flex-shrink: 0;
          }
          .chip-svg:hover {
            color: #666666;
          }
        }
      }
    }
    .large-screen {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: start;
      width: 100%;
      @media (min-width: 320px) and (max-width: 1800px) {
        display: none;
      }
      .date-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        border: 1px solid #c8c8c880;
        padding: 5px 5px 12px 20px;
        margin: 10px 0;
        border-radius: 5px;
        width: 100%;
        margin-bottom: 200px;
        &:hover {
          border: 1px solid #9b9a9a80;
        }
      }
      .action-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        width: 100%;

        .dt-button {
          margin-right: 2px !important;
          padding: 0 10px;
        }
      }
    }
  }
  .v3 {
    font-weight: 400 !important;
    color: #0087ff;
    opacity: 1;
  }
  .menu-container {
    margin-top: 0px !important;
  }
  .dropdown {
    padding: 0px;
  }
  .fc2-datepicker .menu .menu__activator .date-control {
    padding: 1px 2px 1px 0px;
  }
}
</style>